import { grey } from '@mui/material/colors';
import { createStyles, makeStyles } from '@mui/styles';
import { NumberMultipleCheckboxCellProps } from './NumberMultipleCheckbox.props';

// Use createStyles and makeStyles with theme and NumberMultipleCheckboxCellProps
const useNumberMultipleCheckboxStyles = makeStyles(({
  isEditableTitleCell = false,
  rightAlignContent = false,
}: NumberMultipleCheckboxCellProps) =>
  createStyles({
    // Outer flex row that replaces MUI FormControlLabel. DOM order is
    // [number-label, Checkbox]; plain row direction with `flex-end` packs both
    // against the right edge (matching the original FormControlLabel
    // labelPlacement="start" + row-reverse trick visually). Title-cell case
    // uses `space-between` to push the label fully left.
    // Critically, the label here is a plain <span> — not tied to the checkbox
    // via htmlFor — so clicks on the number area no longer toggle the
    // checkbox (see NumberMultipleCheckbox.tsx for why).
    controlLabelRoot: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      overflow: 'hidden',
      ...(isEditableTitleCell && { margin: 0 }),
      justifyContent: isEditableTitleCell && !rightAlignContent ? 'space-between' : 'flex-end',
      '&& .MuiCheckbox-root': {
        padding: '2px 0px 0px 3px',
      },
    },
    label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    strike: {
      textDecoration: 'line-through',
      color: isEditableTitleCell ? grey[500] : grey[700],
    },
    bold: {
      fontWeight: 'bold',
    },
  })
);

export default useNumberMultipleCheckboxStyles;
